export const flagsForLanguage = {
  nl: 'nl',
  af: 'za',
  sq: 'al',
  am: 'et',
  ar: 'sa',
  hy: 'am',
  as: 'in',
  ay: 'bo',
  az: 'az',
  bm: 'ml',
  eu: 'es',
  be: 'by',
  bn: 'bd',
  bho: 'in',
  my: 'mm',
  bs: 'ba',
  bg: 'bg',
  ca: 'es',
  ceb: 'ph',
  ny: 'mw',
  'zh-TW': 'tw',
  'zh-CN': 'cn',
  co: 'fr',
  da: 'dk',
  dv: 'mv',
  doi: 'in',
  de: 'de',
  en: 'gb',
  eo: 'xx',
  et: 'ee',
  ee: 'gh',
  fi: 'fi',
  fr: 'fr',
  fy: 'nl',
  gl: 'es',
  ka: 'ge',
  el: 'gr',
  gn: 'py',
  gu: 'in',
  ht: 'ht',
  ha: 'ng',
  haw: 'us',
  iw: 'il',
  hi: 'in',
  hmn: 'cn',
  hu: 'hu',
  ga: 'ie',
  ig: 'ng',
  is: 'is',
  ilo: 'ph',
  id: 'id',
  it: 'it',
  ja: 'jp',
  jw: 'id',
  yi: 'il',
  kn: 'in',
  kk: 'kz',
  km: 'kh',
  rw: 'rw',
  ky: 'kg',
  ku: 'tr',
  ckb: 'iq',
  gom: 'in',
  ko: 'kr',
  kri: 'sl',
  hr: 'hr',
  lo: 'la',
  la: 'xx',
  lv: 'lv',
  ln: 'cd',
  lt: 'lt',
  lg: 'ug',
  lb: 'lu',
  mk: 'mk',
  mai: 'in',
  mg: 'mg',
  ml: 'in',
  ms: 'my',
  mt: 'mt',
  mi: 'nz',
  mr: 'in',
  'mni-Mtei': 'in',
  lus: 'in',
  mn: 'mn',
  ne: 'np',
  no: 'no',
  or: 'in',
  ug: 'cn',
  uk: 'ua',
  uz: 'uz',
  om: 'et',
  ps: 'af',
  fa: 'ir',
  pl: 'pl',
  pt: 'pt',
  pa: 'in',
  qu: 'pe',
  ro: 'ro',
  ru: 'ru',
  sm: 'ws',
  sa: 'in',
  gd: 'gb',
  nso: 'za',
  sr: 'rs',
  st: 'ls',
  sn: 'zw',
  sd: 'pk',
  si: 'lk',
  sk: 'sk',
  sl: 'si',
  su: 'id',
  so: 'so',
  es: 'es',
  sw: 'tz',
  tg: 'tj',
  tl: 'ph',
  ta: 'in',
  tt: 'ru',
  te: 'in',
  th: 'th',
  ti: 'er',
  cs: 'cz',
  ts: 'za',
  tk: 'tm',
  tr: 'tr',
  ak: 'gh',
  ur: 'pk',
  vi: 'vn',
  cy: 'gb',
  xh: 'za',
  yo: 'ng',
  zu: 'za',
  sv: 'se'
};
